<template>
    <div style="width: 450px;">
        <img src="@/assets/images/nylogo.png" alt="" srcset="" height="32">
        <div class="login-input">
            <svg class="icon login-input-i" aria-hidden="true">
                <use xlink:href="#gold-icon-yonghuming"></use>
            </svg>
            <input v-model="username" placeholder="请输入用户名" @blur="checkInput('username')" maxlength="20" />
            <span class="login-err" v-show="usernameErr && !username">用户名不能为空</span>
            <span class="login-input-length">{{ username.length }}/20</span>
        </div>
        <div class="login-input">
            <svg class="icon login-input-i" aria-hidden="true">
                <use xlink:href="#gold-icon-mima"></use>
            </svg>
            <input v-model="password" placeholder="请输入密码" type="password" @blur="checkInput('password')"
                maxlength="16" />
            <span class="login-err" v-show="passwordErr && password.length < 8">{{ password.length == 0 ? "密码不能为空" :
                "请输入有效的密码" }}</span>
            <span class="login-input-length">{{ password.length }}/16</span>
        </div>
        <div class="login-input flexStart">
            <svg class="icon login-input-i" aria-hidden="true">
                <use xlink:href="#gold-icon-yanzhengma"></use>
            </svg>
            <input v-model="captcha" placeholder="请输入验证码" @keyup.enter="login" @blur="checkInput('captcha')"
                maxlength="4" style="flex:1;margin-right:30px;" />
            <div>
                <img :src="imgUrl" @click="varyCode()" style="width:120px;">
            </div>
            <span class="login-err" v-show="captchaErr && captcha.length != 4" style="bottom:-27px;">{{ captcha.length
                == 0 ? "验证码不能为空" : "请输入有效的验证码" }}</span>
            <span class="login-input-length" style="right:156px;">{{ captcha.length }}/4</span>
        </div>
        <div class="login-btn-box">
            <a-button :loading="loadLogin" type="primary" @click="login" class="login-btn"
                :disabled="!checkInput()">登录</a-button>
            <div class="login-register"><span class="login-forget" @click="toForget">忘记密码 </span> <span
                    style="margin:0 8px;">·</span> <span @click="toRegister"> 立即注册</span></div>
        </div>

    </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { loginApi } from "@/api/login";
import { JSEncrypt } from "jsencrypt";
import { systemDate } from "@/api/communal";
export default {
    data() {
        return {
            tenantName: "蔷薇商业保理有限公司",
            username: "",
            password: "",
            captcha: "",
            pubKey:
                "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJs93/+qTGnMr68IZoEZjmwlkiJ5lhD+HE6GQMiu/giAjCthA2G8+ri679/FmsryLXqUOEUSYBVmkl2gjmD8XhgYx9BEfO00qhz5uvnhTLNN4RKha8Epsx07EqTm6+LWYdFwuf4MIlKVy3B1YZN9qamyWelXoiDILtf78vFLvnOQIDAQAB",
            encrypt: new JSEncrypt(),
            sequence: Math.floor(Math.random() * 1e13),
            usernameErr: false,
            passwordErr: false,
            captchaErr: false,
            loadLogin: false,
        };
    },
    computed: {
        imgUrl() {
            return process.env.VUE_APP_BASE_API + '/captcha/login?v=' + this.sequence;
        }
    },
    methods: {

        ...mapMutations({
            setUserObj: "home/setUserObj",
        }),
        checkInput(type) {
            switch (type) {
                case "username":
                    this.usernameErr = (this.username.length == 0); break;
                case "password":
                    this.passwordErr = (this.password.length < 8); break;
                case "captcha":
                    this.captchaErr = (this.captcha.length != 4); break;
                default:
                    return this.username.length > 0
                        && this.password.length >= 6
                        && this.captcha.length == 4;
            }
        },
        varyCode() {
            this.sequence = Math.floor(Math.random() * 1e13);
        },
        login() {
            if (this.captcha.length < 4) {
                return;
            }
            this.loadLogin = true;
            const data = {
                username: this.username,
                password: this.password,
                captcha: this.captcha,
            };
            const params = this.utils.deepClone(data);
            this.encrypt.setPublicKey(this.pubKey);
            params.password = this.encrypt.encrypt(params.password);

            loginApi(params)
                .then((res) => {
                    this.getSystemDate();
                    this.$router.push({ path: "/main" });
                    this.$message.success("登录成功");
                })
                .catch((err) => {
                    this.loadLogin = false;
                    this.varyCode();
                });
        },
        getSystemDate() {
            systemDate()
                .then((res) => {
                    window.sessionStorage.setItem("systemDate", res.data.substring(0, 10));
                })
                .catch((err) => { console.log(err); });
        },

        toRegister() {
            this.$router.push("/login/register")
        },
        toForget() {
            this.$router.push("/forget-passwd")
        }
    },
    created() { },
    mounted() { }
}
</script>
<style scoped>
footer {
    position: absolute;
    bottom: 0;
    line-height: 40px;
    width: 100%;
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
}

.footer-text {
    width: 80%;
    margin: 0 auto;
}

.login-input {
    margin: 23px 0 0;
    line-height: 40px;
    position: relative;
}

.login-err {
    position: absolute;
    color: red;
    left: 0;
    bottom: -32px;
    font-size: 12px;
    transition: all ease 0.4s;
}

.login-input input {
    width: 100%;
    border: none;
    outline: none;
    border-bottom: 1px solid #ddd;
    line-height: 40px;
    height: 40px;
    padding-left: 24px;
}

.login-input input:focus {
    border-color: #1990FF;
    transition: border-color 0.5s ease;
    -moz-transition: border-color 0.5s ease;
    /* Firefox 4 */
    -webkit-transition: border-color 0.5s ease;
    /* Safari 和 Chrome */
    -o-transition: border-color 0.5s ease;
}

.login-input-focus::after {
    content: '';
    display: inline-block;
    width: 100%;
    height: 1px;
    background-color: #1990FF;
    transition: all 0.5s ease;
}

.login-btn-box {
    margin: 50px 0 30px;
    font-size: 14px;
}

.login-btn {
    width: 100%;
    border: none;
    height: 44px;
    font-size: 18px;
}

.login-register {
    color: #1990FF;
    cursor: pointer;
    text-align: center;
    margin-top: 20px;
}

.login-forget {
    cursor: pointer;
}

.login-input-length {
    position: absolute;
    top: 6px;
    right: 20px;
    color: #d8d8d8;
    font-size: 12px;
}

.login-title {
    font-weight: bold;
    font-size: 18px;
}

.login-input-i {
    font-size: 18px;
    position: absolute;
    left: 0;
    top: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components-frame/login-form.vue